import React from "react";

/* Real Rider-Waite (1909, public domain) tarot card art for the lens cards.
   Files live in /public/tarot/. */
const TAROT_LABELS = {
  lovers: "VI · The Lovers",
  magician: "I · The Magician",
  hermit: "IX · The Hermit",
  wheel: "X · Wheel of Fortune",
  star: "XVII · The Star",
  empress: "III · The Empress",
  hangedman: "XII · The Hanged Man",
};

export default function TarotCardArt({ slug, tarotName, lensLabel }) {
  const tarotLabel = TAROT_LABELS[slug] || tarotName || "";
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "6px 4px 8px",
        gap: 8,
      }}
    >
      <img
        src={`/tarot/${slug}.jpg`}
        alt={tarotName}
        style={{
          width: "100%",
          flex: 1,
          minHeight: 0,
          objectFit: "contain",
          display: "block",
          filter: "sepia(0.45) saturate(0.8) hue-rotate(-12deg) brightness(0.95) contrast(1.04)",
        }}
        draggable={false}
      />
      <p style={{
        fontFamily: "'Space Mono', monospace",
        fontSize: 8.5,
        letterSpacing: "0.04em",
        color: "var(--terracotta-soft)",
        margin: 0,
        textTransform: "uppercase",
        textAlign: "center",
        lineHeight: 1.4,
        maxWidth: "100%",
      }}>
        [ {tarotLabel} <span style={{ color: "var(--dim)", margin: "0 3px" }}>|</span> <span style={{ color: "var(--cream)" }}>{lensLabel}</span> ]
      </p>
    </div>
  );
}
